/* oxlint-disable @typescript-eslint/no-explicit-any */
import { Pipe, PipeTransform } from "@angular/core";

import { Category } from "@hermes/api-model-menu";

@Pipe({
    name: "asMenuEntryItemWithEdito",
})
export class AsMenuEntryItemWithEditoPipe implements PipeTransform {
    public transform(value: Category | undefined): any {
        if (value) {
            return value as any;
        }

        return undefined;
    }
}
